<template>
    <div class="my-view-body article-detail-page" v-title :data-title="title">
        <el-container class="my-view-container">
            <!--<el-aside class="my-area">-->
            <!--<ul class="my-operation-list">-->
            <!--<li class="my-operation-item">-->
            <!--<el-button type="primary" icon="el-icon-edit"></el-button>-->
            <!--</li>-->
            <!--</ul>-->
            <!--</el-aside>-->
            <el-main>

                <div class="my-view-card cyber-article-card">
                    <!--标题-->
                    <h1 class="my-view-title">{{article.title}}</h1>

                    <div class="my-view-author">
                        <!--作者头像-->
                        <a class="">
                            <img class="my-view-picture" :src="avatar"></img>
                        </a>
                        <!--作者信息-->
                        <div class="my-view-info">
                            <span>{{article.author}}</span>
                            <div class="my-view-meta">
                                <span>{{article.createDate}}</span>&nbsp;
                                <span>阅读 {{article.viewCounts}}</span>&nbsp;&nbsp;
                                <span>评论 {{article.commentCounts}}</span>
                            </div>
                        </div>
                        <!--文章编辑-->
                        <el-button
                                v-if="this.article.authorId == this.$store.state.id"
                                @click="editArticle()"
                                style="position: absolute;left: 60%;"
                                size="mini"
                                round
                                icon="el-icon-edit">编辑
                        </el-button>
                    </div>
                    <!--markdown编辑器-->
                    <div class="my-view-content">
                        <markdown-editor :editor=article.editor></markdown-editor>
                    </div>

                    <div class="my-view-end">
                        <el-alert
                                title="文章End..."
                                type="success"
                                center
                                :closable="false">
                        </el-alert>
                    </div>
                    <!--文章标签-->
                    <div class="my-view-tag">
                        标签：
                        <!--<el-tag v-for="t in article.tags" :key="t.id" class="my-view-tag-item" size="mini" type="success">{{t.tagName}}</el-tag>-->
                        <el-button @click="tagOrCategory('tag', t.id)" size="mini" type="primary"
                                   v-for="t in article.tags" :key="t.id" round plain>{{t.tagName}}
                        </el-button>
                    </div>
                    <!--文章分类-->
                    <div class="my-view-tag">
                        文章分类：
                        <!--<span style="font-weight: 600">{{article.category.categoryName}}</span>-->
                        <el-button @click="tagOrCategory('category', article.category.id)" size="mini" type="primary"
                                   round plain>{{article.category.categoryName}}
                        </el-button>
                    </div>

                    <div class="my-view-comment">
                        <div class="my-view-comment-write">
                            <el-row :gutter="20">
                                <!--照片-->
                                <el-col :span="2">
                                    <a class="">
                                        <img class="my-view-picture" :src="avatar"></img>
                                    </a>
                                </el-col>
                                <!--评论-->
                                <el-col :span="22">
                                    <el-input
                                            type="textarea"
                                            :autosize="{ minRows: 2}"
                                            placeholder="你的评论..."
                                            class="my-view-comment-text"
                                            v-model="comment.content"
                                            resize="none">
                                    </el-input>
                                </el-col>
                            </el-row>

                            <el-row :gutter="20">
                                <el-col :span="2" :offset="22">
                                    <el-button type="text" @click="publishComment()">评论</el-button>
                                </el-col>
                            </el-row>
                        </div>

                        <div class="my-view-comment-title">
                            <span>{{article.commentCounts}} 条评论</span>
                        </div>

                        <!--评论组件，后台中的评论列表是从最新到最旧，
                        所以最新的应该是评论数量减去索引值0，就是该楼层-->
                        <commment-item
                                v-for="(c,index) in comments"
                                :comment="c"
                                :articleId="article.id"
                                :index="index"
                                :rootCommentCounts="comments.length"
                                @commentCountsIncrement="commentCountsIncrement"
                                @findCommentListByArticleId="findCommentListByArticleId"
                                :key="c.id">
                        </commment-item>

                    </div>

                </div>
            </el-main>

        </el-container>
    </div>
</template>

<script>
    import {getToken, setToken, removeToken} from "../../request/token"
    import {findArticleDetailById} from "@/api/article"
    import {findCommentListByArticleId, publishComment} from "@/api/comment"
    import MarkdownEditor from "@/components/markdown/MarkdownEditor"
    import CommentItem from "@/components/comment/CommentItem"
    import default_avatar from '@/assets/img/default_avatar.png'

    export default {
        name: "ArticleItemDetail",
        data() {
            return {
                article: {
                    id: '',
                    title: '',
                    authorId: "",
                    commentCounts: 0,
                    viewCounts: 0,
                    summary: '',
                    author: {},
                    tags: [],
                    category: {},
                    createDate: '',
                    editor: {
                        value: '',
                        toolbarsFlag: false,
                        subfield: false,
                        defaultOpen: 'preview'
                    }
                },
                comments: [],
                comment: {
                    article: {},
                    content: ''
                },
            }
        },
        computed:
            {
                title() {
                    return `${this.article.title}文章详情`
                },
                avatar() {
                    let avatar = this.$store.state.avatar;

                    if (avatar.length > 0) {
                        return avatar
                    }
                    return default_avatar
                },
            },
        methods:
            {
                /*文章详情*/
                findArticleById() {
                    let loading = this.$loading({
                        lock: true,
                        text: '加载中，请稍后...'
                    });
                    let id = this.$route.params.id;
                    findArticleDetailById(id).then((res) => {
                        if (res.data.success) {
                            console.log("文章详情",res);
                            Object.assign(this.article, res.data.data);
                            /*将文章内容传给markdown编辑器*/
                            this.article.editor.value = res.data.data.body.content;
                            loading.close();
                        } else {
                            this.$message.error(res.data.msg);
                            loading.close();
                        }
                    }).catch((err) => {
                        this.$message.error("系统错误");
                        loading.close();
                    }).finally(() => {
                    });

                },
                /*文章的评论列表*/
                findCommentListByArticleId() {
                    let id = this.$route.params.id;
                    findCommentListByArticleId(id).then((res) => {
                        if (res.data.success) {
                            this.comments = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch((err) => {
                        this.$message.error("系统错误")
                    }).finally(() => {

                    });
                },
                /*点击编辑文章，跳转到写文章页面，通过传递的this.article.id控制是写文章还是编辑文章*/
                editArticle() {
                    this.$router.push({path: `/write/${this.article.id}`})
                },
                /*点击某个标签或者分类，跳转到对应的详情页面*/
                tagOrCategory(type, id) {
                    this.$router.push({path: `/${type}/${id}`})
                },
                /*发表评论*/
                publishComment() {
                    if (!this.comment.content) {
                        this.$message({message: "评论内容不能为空哦", type: "warning", showClose: true})
                        return;
                    }

                    let commentParams = {articleId: this.article.id, content: this.comment.content}
                    publishComment(commentParams, getToken()).then((res) => {
                        if (res.data.success) {
                            this.$message({type: 'success', message: '评论成功', showClose: true})
                            this.comment.content = '';
                            /*评论成功后，文章的评论数量增加1*/
                            this.commentCountsIncrement();
                            this.findCommentListByArticleId();
                        } else {
                            this.$message({type: 'error', message: res.data.msg, showClose: true})
                        }
                    }).catch((error) => {
                        if (error !== 'error') {
                            this.$message({type: 'error', message: '评论失败', showClose: true})
                        }
                    })
                },
                /*CommentItem.vue组件中评论成功之后，文章的评论数量自增1*/
                commentCountsIncrement() {
                    this.article.commentCounts += 1;
                }
            },
        components:
            {
                "markdown-editor": MarkdownEditor,
                "commment-item": CommentItem
            },
        created() {
            this.findArticleById();
            this.findCommentListByArticleId();
        },
    }

</script>

<style scoped>
    .my-view-body {
        margin: 100px auto 140px;
    }

    .my-view-container {
        width: 100%;
        max-width: 880px;
        margin: 0 auto;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .my-view-body .el-main {
        overflow: hidden;
        padding: 0;
    }

    .my-view-title {
        font-size: 34px;
        font-weight: 800;
        line-height: 1.3;
    }

    .my-view-author {
        margin-top: 30px;
        vertical-align: middle;
    }

    .my-view-picture {
        width: 40px;
        height: 40px;
        border: 1px solid #ddd;
        border-radius: 50%;
        vertical-align: middle;
        background-color: #5fb878;
    }

    .my-view-info {
        display: inline-block;
        vertical-align: middle;
        margin-left: 8px;
    }

    .my-view-meta {
        font-size: 12px;
        color: #969696;
    }

    .my-view-end {
        margin-top: 20px;
    }

    .my-view-tag {
        margin-top: 20px;
        padding-left: 6px;
        border-left: 4px solid #c5cac3;
    }

    .my-view-tag-item {
        margin: 0 4px;
    }

    .my-view-comment {
        margin-top: 60px;
    }

    .my-view-comment-title {
        font-weight: 600;
        border-bottom: 1px solid #f0f0f0;
        padding-bottom: 20px;
    }

    .my-view-comment-write {
        margin-top: 20px;
    }

    .my-view-comment-text {
        font-size: 16px;
    }
</style>

<style>
    /* 文章详情：居中 + 科技风（非 scoped，覆盖 mavon-editor） */
    .article-detail-page .my-view-container {
        width: 100%;
        max-width: 880px;
        margin: 0 auto;
        padding: 0 20px;
        box-sizing: border-box;
    }

    /* 科技风卡片容器 */
    .article-detail-page .my-view-card.cyber-article-card {
        background: rgba(10, 15, 28, 0.55);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        border: 1px solid rgba(0, 255, 245, 0.25);
        border-radius: 16px;
        padding: 32px 40px 40px;
        box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 0 0 1px rgba(236, 72, 153, 0.06);
    }

    .article-detail-page .my-view-title {
        color: rgba(224, 242, 254, 0.98);
        text-shadow: 0 0 20px rgba(0, 255, 245, 0.15);
    }

    .article-detail-page .my-view-info span {
        color: rgba(224, 242, 254, 0.9);
    }

    .article-detail-page .my-view-meta {
        color: rgba(148, 163, 184, 0.95);
    }

    .article-detail-page .my-view-picture {
        border-color: rgba(0, 255, 245, 0.35);
        box-shadow: 0 0 12px rgba(0, 255, 245, 0.2);
    }

    .article-detail-page .my-view-tag {
        border-left-color: rgba(0, 255, 245, 0.5);
        color: rgba(203, 213, 225, 0.9);
    }

    .article-detail-page .my-view-tag .el-button--primary.is-plain {
        background: rgba(0, 255, 245, 0.1);
        border-color: rgba(0, 255, 245, 0.4);
        color: #00fff5;
    }

    .article-detail-page .my-view-tag .el-button--primary.is-plain:hover {
        background: rgba(0, 255, 245, 0.2);
        border-color: rgba(0, 255, 245, 0.6);
        color: #00fff5;
        box-shadow: 0 0 16px rgba(0, 255, 245, 0.25);
    }

    .article-detail-page .my-view-end .el-alert--success {
        background: rgba(0, 255, 245, 0.08);
        border: 1px solid rgba(0, 255, 245, 0.25);
        color: rgba(203, 213, 225, 0.9);
    }

    .article-detail-page .my-view-end .el-alert__title {
        color: rgba(224, 242, 254, 0.9);
    }

    .article-detail-page .my-view-comment-title {
        border-bottom-color: rgba(0, 255, 245, 0.2);
        color: rgba(224, 242, 254, 0.95);
    }

    .article-detail-page .my-view-comment-text .el-textarea__inner {
        background: rgba(10, 15, 28, 0.5);
        border: 1px solid rgba(0, 255, 245, 0.2);
        color: rgba(224, 242, 254, 0.95);
    }

    .article-detail-page .my-view-comment-text .el-textarea__inner::placeholder {
        color: rgba(148, 163, 184, 0.7);
    }

    .article-detail-page .my-view-comment .el-button--text {
        color: #00fff5;
    }

    .article-detail-page .my-view-comment .el-button--text:hover {
        color: #00fff5;
        text-shadow: 0 0 10px rgba(0, 255, 245, 0.5);
    }

    .article-detail-page .my-view-author .el-button--mini {
        color: #00fff5;
        border-color: rgba(0, 255, 245, 0.4);
    }

    /* Markdown 正文区域：去掉灰色，统一科技风深色玻璃 */
    .article-detail-page .my-view-content,
    .article-detail-page .my-view-content .v-note-wrapper,
    .article-detail-page .my-view-content .v-note-wrapper .v-note-panel,
    .article-detail-page .my-view-content .v-note-wrapper .v-note-panel .v-note-show,
    .article-detail-page .my-view-content .v-note-wrapper .v-note-panel .v-note-edit-panel,
    .article-detail-page .v-note-wrapper,
    .article-detail-page .v-note-wrapper .v-note-panel,
    .article-detail-page .v-note-wrapper .v-note-panel .v-note-show {
        background: transparent !important;
        box-shadow: none !important;
    }

    .article-detail-page .v-show-content,
    .article-detail-page .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
    .article-detail-page .v-note-wrapper .v-note-panel .v-note-show .v-show-content-html,
    .article-detail-page .v-note-wrapper .v-note-panel .v-note-show .v-content,
    .article-detail-page .v-note-show .v-show-content,
    .article-detail-page .v-note-show .v-show-content-html {
        padding: 12px 28px 20px 32px !important;
        background: rgba(8, 12, 24, 0.7) !important;
        background-image: linear-gradient(135deg, rgba(0, 255, 245, 0.03) 0%, transparent 50%) !important;
        color: rgba(213, 225, 239, 0.95) !important;
        border-radius: 12px;
        border: 1px solid rgba(0, 255, 245, 0.18);
        box-shadow: inset 0 0 40px rgba(0, 255, 245, 0.02), 0 4px 24px rgba(0, 0, 0, 0.3) !important;
    }

    .article-detail-page .v-show-content h1,
    .article-detail-page .v-show-content h2,
    .article-detail-page .v-show-content h3,
    .article-detail-page .v-show-content h4,
    .article-detail-page .v-show-content h5,
    .article-detail-page .v-show-content h6 {
        color: rgba(224, 242, 254, 0.98) !important;
        border-bottom-color: rgba(0, 255, 245, 0.2) !important;
    }

    .article-detail-page .v-show-content p,
    .article-detail-page .v-show-content li,
    .article-detail-page .v-show-content blockquote,
    .article-detail-page .v-show-content div {
        color: rgba(213, 225, 239, 0.92) !important;
    }

    .article-detail-page .v-show-content blockquote {
        border-left-color: rgba(0, 255, 245, 0.4);
        background: rgba(0, 255, 245, 0.04);
    }

    .article-detail-page .v-show-content code {
        background: rgba(0, 255, 245, 0.1) !important;
        color: #00fff5 !important;
        border: 1px solid rgba(0, 255, 245, 0.2);
        border-radius: 4px;
    }

    .article-detail-page .v-show-content pre {
        background: rgba(10, 15, 28, 0.6) !important;
        border: 1px solid rgba(0, 255, 245, 0.2);
        border-radius: 8px;
    }

    .article-detail-page .v-show-content pre code {
        background: transparent !important;
    }

    .article-detail-page .v-show-content a {
        color: #00fff5 !important;
    }

    .article-detail-page .v-show-content a:hover {
        text-shadow: 0 0 10px rgba(0, 255, 245, 0.4);
    }

    .article-detail-page .v-show-content table th,
    .article-detail-page .v-show-content table td {
        border-color: rgba(0, 255, 245, 0.2) !important;
        color: rgba(203, 213, 225, 0.9) !important;
    }

    .article-detail-page .v-show-content hr {
        border-color: rgba(0, 255, 245, 0.2) !important;
    }

    /* 兜底：正文区域内任何灰色/白色背景都改为透明或深色 */
    .article-detail-page .my-view-content [class*="v-note"] {
        background: transparent !important;
    }

    .article-detail-page .my-view-content .v-note-show .v-content,
    .article-detail-page .my-view-content .v-note-show .v-content pre {
        background: transparent !important;
    }
</style>
